<div class="container-fluid py-4">
    <div class="d-flex justify-content-between align-items-center mb-3">
        <h2>Knowledge Base Items for {{ serviceAreaName }}</h2>

        <button type="button" class="btn btn-primary" [routerLink]="['/knowledge-base-item/create', serviceAreaId]" readOnlyIfNoGroupPermissionDirective [showToastWhenRendering]="false">
            <i class="bi bi-plus-lg me-2"></i> Add New Item
        </button>

        <!-- Import Knowledge Base Items Button -->
        <button class="btn btn-warning" *ngIf="isAllowedTenant" (click)="fileInput.click()">
            <i class="bi bi-upload"></i> Import KB Items
        </button>        
        <input type="file" #fileInput (change)="onFileSelected($event)" accept=".csv" class="d-none">      
    </div>

    <div class="d-flex justify-content-between mb-3">
        <input type="text" class="form-control me-2" placeholder="Search Knowledge Base Items..."
            [(ngModel)]="searchQuery" (input)="filterKnowledgeBaseItems()" />
        <button class="btn btn-outline-secondary" (click)="clearSearch()">Clear</button>
    </div>

    <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="d-flex flex-column">
            <button class="btn btn-outline-secondary btn-sm mb-2" (click)="toggleCheckboxVisibility()">
                <i [ngClass]="isCheckboxVisible ? 'bi bi-eye-slash' : 'bi bi-eye'" class="me-1"></i>
                {{ isCheckboxVisible ? 'Hide Selection' : 'Enable Selection' }}
            </button>

            
        </div>
        <ng-container *ngIf="isCheckboxVisible">
            <button class="btn btn-primary btn-sm" [disabled]="!anySelected" (click)="openBulkMoveModal(bulkMoveModal)" readOnlyIfNoGroupPermissionDirective [showToastWhenRendering]="false">
                Move Selected
            </button>
        </ng-container>
    </div>

    <div class="card shadow-sm">
        <div class="card-header bg-primary text-white">
            <h5 class="mb-0">Knowledge Base Item List</h5>
        </div>
        <div class="card-body p-0">
            <ag-grid-angular #knowledgeBaseGrid class="ag-theme-alpine" style="height: 600px; width: 100%;"
                [gridOptions]="gridOptions" [loading]="true" (gridReady)="onGridReady($event)"
                [rowData]="filteredKnowledgeBaseItems" [rowSelection]="rowSelection"
                (selectionChanged)="onSelectionChanged()">
            </ag-grid-angular>
        </div>
    </div>
</div>

<!-- Delete Modal -->
<ng-template #deleteConfirmModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title text-danger"><i class="bi bi-exclamation-triangle"></i> Confirm Deletion</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <p>Are you sure you want to delete this Knowledge Base Item?</p>
        <p class="text-muted small">This action cannot be undone.</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
        <button type="button" class="btn btn-danger" (click)="confirmDeleteItem(modal)">Delete</button>
    </div>
</ng-template>

<!-- Move Modal -->
<ng-template #moveModal let-modal>
    <form #moveForm="ngForm">
        <div class="modal-header">
            <h5 class="modal-title">Move Knowledge Base Item</h5>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body">
            <p>Select the service area to move <strong>{{moveDetails.item.description}}</strong>:</p>
            <div class="mb-3">
                <label for="targetServiceArea" class="form-label">Target Service Area</label>
                <select id="targetServiceArea" name="targetServiceArea" [(ngModel)]="moveDetails.targetServiceAreaId"
                    class="form-control" required>
                    <option [ngValue]="null">-- Select Service Area --</option>
                    <option *ngFor="let area of serviceAreas" [ngValue]="area.id">{{ area.name }}</option>
                </select>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel click')">Cancel</button>
            <button type="button" class="btn btn-primary" [disabled]="moveForm.invalid"
                (click)="moveItem(modal)">Confirm</button>
        </div>
    </form>
</ng-template>

<!-- Bulk Modal -->
<ng-template #bulkMoveModal let-modal>
    <form #bulkMoveForm="ngForm">
        <div class="modal-header">
            <h5 class="modal-title">Move Selected Knowledge Base Items</h5>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body">
            <p>You are about to move <strong>{{ moveDetails.selectedCount }}</strong> items.</p>
            <div class="mb-3">
                <label for="bulkTargetServiceArea" class="form-label">Target Service Area</label>
                <select id="bulkTargetServiceArea" name="bulkTargetServiceArea"
                    [(ngModel)]="moveDetails.targetServiceAreaId" class="form-control" required>
                    <option [ngValue]="null">-- Select Service Area --</option>
                    <option *ngFor="let area of serviceAreas" [ngValue]="area.id">{{ area.name }}</option>
                </select>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel click')">Cancel</button>
            <button type="button" class="btn btn-primary" [disabled]="bulkMoveForm.invalid"
                (click)="bulkMoveItem(modal)">Confirm</button>
        </div>
    </form>
</ng-template>